import * as React from 'react';
import { IRecentSearchTile } from '../../../pages/home/utilities/types';
import Carousel from './Carousel';
import RecentSearchTile from '../../../pages/home/hero/recent-search-tile/RecentSearchTile';

interface IReturnVisitorRecentSearchesCarouselProps {
    isVisible: boolean;
    recentSearchTileList: IRecentSearchTile[];
    analyticsName: string;
    carouselName: string;
    ariaLabel: string;
    leftAligned: boolean;
}

interface IReturnVisitorRecentSearchesCarouselState {
    recentSearchTileList: IRecentSearchTile[];
    carouselItems: React.ReactElement[];
}

export default class ReturnVisitorRecentSearchesCarousel extends React.Component<
    IReturnVisitorRecentSearchesCarouselProps,
    IReturnVisitorRecentSearchesCarouselState
> {
    constructor(props: IReturnVisitorRecentSearchesCarouselProps) {
        super(props);
        this.state = {
            recentSearchTileList: this.props.recentSearchTileList,
            carouselItems: this.buildCarouselItems(this.props.recentSearchTileList),
        };

        this.buildCarouselItems = this.buildCarouselItems.bind(this);
    }

    private buildCarouselItems(recentSearchTileList: IRecentSearchTile[]): React.ReactElement[] {
        const carouselItems: React.ReactElement[] = [];

        if (recentSearchTileList && recentSearchTileList.length > 0) {
            recentSearchTileList.forEach((recentSearchTile: IRecentSearchTile, index: number) => {
                const linkAttrs: { [key: string]: any } = {};
                linkAttrs.tabIndex = 0;

                carouselItems.push(
                    <div className="carousel__slide" key={`recent-search-slide-${index}`}>
                        <div className="carousel-slide-item">
                            <RecentSearchTile linkAttrs={linkAttrs} recentSearchTile={recentSearchTile} />
                        </div>
                    </div>
                );
            });
        }

        return carouselItems;
    }

    public componentDidUpdate(prevProps: IReturnVisitorRecentSearchesCarouselProps): void {
        const recentSearchTilesHaveUpdated =
            JSON.stringify(prevProps.recentSearchTileList) !== JSON.stringify(this.props.recentSearchTileList);

        if (recentSearchTilesHaveUpdated) {
            this.setState({
                carouselItems: this.buildCarouselItems(this.props.recentSearchTileList),
            });
        }
    }

    public render(): React.ReactNode {
        return (
            <div id="kmx-recent-searches-carousel" className="carousel-container">
                <Carousel
                    name={`${this.props.carouselName}-return-visitor`}
                    nextFocus="#budget-calculator-section"
                    ariaLabel={this.props.ariaLabel}
                    leftAligned={this.props.leftAligned}
                >
                    {this.state.carouselItems.map((item) => item)}
                </Carousel>
            </div>
        );
    }
}
